module.exports = __webpack_public_path__ + "img/close-gray.34d02519.svg";